import React from 'react';
import classNames from 'classnames';
import {FormattedHTMLMessage, useIntl} from 'react-intl';
import MessageIfPresent from '../MessageIfPresent.jsx';
import {getMessageValue} from '../../i18n/messageUtil.mjs';
import PropTypes from 'prop-types';
import {useText} from '../TextContext';

const QuestionGroupHeader = props => {
  const { questionGroup, className } = props;
  const textContext = useText();
  const classes = classNames(className, 'questionGroup__header');
  const intl = useIntl();
  const hasLabel = textContext?.[`${questionGroup.key}`] || getMessageValue(intl.locale, `${questionGroup.key}`);
  const hasSubtext = textContext?.[`${questionGroup.key}.subtext`] || getMessageValue(intl.locale, `${questionGroup.key}.subtext`);

  const label = textContext?.[`${questionGroup.key}`] ||  (
    <MessageIfPresent id={`${questionGroup.key}`}>
      <FormattedHTMLMessage id={questionGroup.key} />
    </MessageIfPresent>
  );
  const subtext = textContext?.[`${questionGroup.key}`]?.subtext || (
    <MessageIfPresent id={`${questionGroup.key}.subtext`}>
      <FormattedHTMLMessage id={`${questionGroup.key}.subtext`} />
    </MessageIfPresent>
  );

  return hasLabel && (
    <h1 className={classes}>
      {label}
      {hasSubtext && <div className="subtext">{subtext}</div>}
    </h1>
  );
};

QuestionGroupHeader.propTypes = {
  questionGroup: PropTypes.any,
  className: PropTypes.string,
};

export default QuestionGroupHeader;
